// extracted by mini-css-extract-plugin
export default {"back":"Background_back__JlU3D"};